import clsx from 'clsx';

import { Icon, IconButton } from '@atom/mui';
import colors from '@atom/styles/colors';
import { AssetDetailView } from '@atom/types/inventory';

import classes from './header.module.css';

interface Props {
  view: {
    value: AssetDetailView;
    label: string;
    icon: any;
    dataCy?: string;
  };
  activeView: AssetDetailView;
  setActiveView: (activeView: AssetDetailView) => void;
}

const HeaderNavigationIcon = ({ view, activeView, setActiveView }: Props) => {
  const { value, dataCy, icon, label } = view;

  const activeClassName = clsx(
    classes.iconContainer,
    activeView === value && classes.active,
  );

  return (
    <div
      onClick={() => setActiveView(value)}
      className={activeClassName}
      data-cy={dataCy}
    >
      <IconButton>
        <Icon color={colors.neutral.white}>{icon}</Icon>
      </IconButton>
      <div className={classes.label}>{label}</div>
    </div>
  );
};

export default HeaderNavigationIcon;
